/**
 * Факти вакансії таблетками: локація, досвід, оплата (owner 2026-09-20).
 *
 * Власник: «оно будет показываться в таком формате, как у нас показывается
 * источник, категория, тип занятости… не так, что локация двоеточие Киев, а
 * именно как факты». Тому — той самий вигляд таблетки, без підписів.
 * Чого в тексті вакансії не було — того й немає: порожній факт рядка не дає.
 */
export function FactPills({
  pay,
  experience,
  location,
  className = "",
}: {
  pay?: string | null;
  experience?: string | null;
  location?: string | null;
  className?: string;
}) {
  const items = [location, experience, pay].filter(
    (v): v is string => !!v && v.trim().length > 0,
  );
  if (items.length === 0) return null;
  return (
    <div className={"flex items-center gap-1.5 flex-wrap " + className}>
      {items.map((text) => (
        <span
          key={text}
          className="inline-block font-mono text-[0.625rem] tracking-[0.02em] text-ink bg-ink/[0.06] px-2 py-0.5 rounded-full"
        >
          {text}
        </span>
      ))}
    </div>
  );
}
